<uoa-header *ngIf="!isMobile()" class="header" logo-position="start" logo-type="horizontal"></uoa-header>
<uoa-header *ngIf="isMobile()" class="header" logo-position="middle" logo-type="vertical"></uoa-header>
